import React, { PropTypes } from "react";
import AcquireWebComponent from "../../framework/MaterialUI";
import { splitNumber } from "../../../utils/utility";

import moment from "moment";
import "./audience_files.css";

class AudienceSummary extends AcquireWebComponent {
  render() {
    const { data } = this.props;
    if (!data) {
      return (
        <div className="light-grey-border bg-white p-20 af-summary-container">
          Loading...
        </div>
      );
    }
    const {
      startDatetime,
      currentMonthConsumerRecords,
      currentMonthBusinessRecords,
      totalConsumerRecords,
      totalBusinessRecords,
    } = data;
    const startDateTimeText = startDatetime
      ? moment.unix(startDatetime / 1000).format("M/D/YY")
      : "";
    return (
      <div className="light-grey-border bg-white p-20 af-summary-container">
        <div className="aa-title">AUDIENCE SUMMARY</div>
        <div className="light-grey-border-top light-grey-border-bottom mt-20 list-sub-title ">
          Records Delivered Since Start Date of {startDateTimeText}
        </div>
        <div className="light-grey-border-bottom list-item ">
          <strong>Consumer</strong> -{" "}
          {totalConsumerRecords ? splitNumber(totalConsumerRecords)() : "0"}
        </div>
        <div className="light-grey-border-bottom list-item ">
          <strong>Business</strong> -{" "}
          {totalBusinessRecords ? splitNumber(totalBusinessRecords)() : "0"}
        </div>
        <div className="light-grey-border-top light-grey-border-bottom mt-20 list-sub-title ">
          Records Delivered Month to Date
        </div>
        <div className="light-grey-border-bottom list-item ">
          <strong>Consumer</strong> -{" "}
          {currentMonthConsumerRecords
            ? splitNumber(currentMonthConsumerRecords)()
            : "0"}{" "}
          Records
        </div>
        <div className="light-grey-border-bottom list-item ">
          <strong>Business</strong> -{" "}
          {currentMonthBusinessRecords
            ? splitNumber(currentMonthBusinessRecords)()
            : "0"}{" "}
          Records
        </div>
      </div>
    );
  }
}

export default AudienceSummary;

AudienceSummary.propTypes = {
  data: PropTypes.object,
  /*
	addAttribute: PropTypes.func.required,
	attributes: PropTypes.object.required, 
	attributesList: PropTypes.array.required, 
	chosenAttributes: PropTypes.array, 
	chosenLookup: PropTypes.object, 
	clearErrorMessage: PropTypes.func, 
	dashboardKey: PropTypes.string,
	dealType: PropTypes.string,
	errorMessage: PropTypes.string, */
};



// WEBPACK FOOTER //
// ./src/components/Insights/audienceFiles/AudienceSummary.jsx